import { Address } from '@vfde-sails/avc-core';
import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { AvcActions, Inputs } from './enum';

export const getEntryState = () => ({
    type: AvcActions.GET_ENTRY_STATE,
} as const);

export const setLoading = (loading: boolean = true) => ({
    type: AvcActions.SET_LOADING,
    loading,
} as const);

export const setError = (error?: Error | ApiErrorResponseWithCode) => ({
    type: AvcActions.SET_ERROR,
    error,
} as const);

export const setAccessSupplier = (accessSupplier: string) => ({
    type: AvcActions.SET_ACCESS_SUPPLIIER,
    accessSupplier,
} as const);

export const setRolloutEndMonth = (rolloutEndMonth: string) => ({
    type: AvcActions.SET_ROLLOUT_END_MONTH,
    rolloutEndMonth,
} as const);

export const setRolloutStatus = (rolloutStatus: string) => ({
    type: AvcActions.SET_ROLLOUT_STATUS,
    rolloutStatus,
} as const);

export const setAvailabilityIndicator = (availabilityIndicator: string) => ({
    type: AvcActions.SET_AVAILABILITY_INDICATOR,
    availabilityIndicator,
} as const);

export const setForm = (index: number) => ({
    type: AvcActions.SET_FORM,
    index,
} as const);

export const setInput = (name: Inputs, value: string) => ({
    type: AvcActions.SET_INPUT,
    name,
    value,
} as const);

export const setAddresses = (addresses: Address[]) => ({
    type: AvcActions.SET_ADDRESSES,
    addresses,
} as const);

export const checkAddress = () => ({
    type: AvcActions.CHECK_ADDRESS,
} as const);

export const resetForm = () => ({
    type: AvcActions.RESET_FORM,
} as const);

export type Actions = ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setInput>
    | ReturnType<typeof setForm>
    | ReturnType<typeof setAddresses>
    | ReturnType<typeof checkAddress>
    | ReturnType<typeof resetForm>
    | ReturnType<typeof setAccessSupplier>
    | ReturnType<typeof setRolloutEndMonth>
    | ReturnType<typeof setRolloutStatus>
    | ReturnType<typeof setAvailabilityIndicator>;
